import intelLogo from "/img/navbar/carousel/intel.svg";
import qualcommLogo from "/img/navbar/carousel/qualcomm.png";
import abimLogo from "/img/navbar/carousel/abim.png";
import siliconLogo from "/img/navbar/carousel/Silicon.png";
import scytLogo from "/img/navbar/carousel/logotipo_SCyT.svg";

export type CollaboratorItem = {
  src: string;
  alt: string;
  subtitleKey: string;
};

export const collaborators: CollaboratorItem[] = [
  { src: intelLogo, alt: "Intel", subtitleKey: "colab_intel" },
  { src: qualcommLogo, alt: "Qualcomm", subtitleKey: "colab_qualcomm" },
  { src: abimLogo, alt: "ABIM", subtitleKey: "colab_abim" },
  { src: siliconLogo, alt: "Silicon", subtitleKey: "colab_silicon" },
  { src: scytLogo, alt: "SCyT", subtitleKey: "colab_scyt" },
];